/* HiSnoot — prototype interactions (mini-cart removed; rebuilt in Task 9) */
(function () {
  'use strict';

  var PACKS = {
    1: { name: '1 Pad', price: 44.95, was: 0, note: '' },
    2: { name: '3 Pads — Buy 2 Get 1 Free', price: 89.90, was: 134.85, note: '$29.97/pad' },
    3: { name: '5 Pads — Buy 3 Get 2 Free', price: 134.85, was: 224.75, note: '' }
  };
  function fmtMoney(n) { return '$' + n.toFixed(2); }

  /* ---------- hero boot animation ---------- */
  document.documentElement.classList.add('boot');
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-boot]').forEach(function (el, i) {
      setTimeout(function () {
        el.style.opacity = '1';
        el.style.transform = 'none';
      }, 120 + i * 110);
    });
  });

  /* ---------- mobile burger ---------- */
  var burger = document.querySelector('.burger');
  var mnav = document.querySelector('.mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.textContent = open ? '✕' : '☰';
      burger.setAttribute('aria-expanded', open);
    });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mnav.classList.remove('open');
        burger.textContent = '☰';
      });
    });
  }

  /* ---------- announcement countdown (evergreen: next local midnight, resets daily) ---------- */
  var cdEl = document.querySelector('[data-countdown]');
  if (cdEl) {
    var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
    var cdTick = function () {
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var left = Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000));
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      cdEl.textContent = pad2(h) + ':' + pad2(m) + ':' + pad2(s);
    };
    cdTick();
    setInterval(cdTick, 1000);
  }

  /* ---------- scroll reveal ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });

  /* ---------- accordions (FAQ + PDP info) ---------- */
  function bindAccordion(rootSel, itemSel) {
    document.querySelectorAll(rootSel + ' ' + itemSel).forEach(function (item) {
      var btn = item.querySelector('button');
      var body = item.querySelector('.a, .body');
      if (!btn || !body) return;
      btn.setAttribute('aria-expanded', item.classList.contains('open'));
      if (item.classList.contains('open')) body.style.maxHeight = body.scrollHeight + 'px';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open);
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
      });
    });
  }
  bindAccordion('.faq', '.q');
  bindAccordion('.acc', '.ai');

  /* ---------- reviews: load more (toont verborgen .rev-hidden kaarten) ---------- */
  document.querySelectorAll('[data-load-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var scope = btn.closest('section') || document;
      scope.querySelectorAll('.rev-hidden').forEach(function (card) {
        card.classList.remove('rev-hidden');
        card.classList.add('in');
      });
      var wrap = btn.closest('.rmore');
      if (wrap) wrap.style.display = 'none';
    });
  });

  /* ---------- count-up numbers ---------- */
  var cuIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      cuIO.unobserve(e.target);
      var el = e.target;
      var target = parseFloat(el.dataset.count);
      var prefix = el.dataset.prefix || '';
      var suffix = el.dataset.suffix || '';
      var dur = 1100, t0 = null;
      function tick(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.bignum [data-count]').forEach(function (el) { cuIO.observe(el); });

  /* ---------- header shadow on scroll ---------- */
  var navBar = document.querySelector('.nav');
  if (navBar) {
    window.addEventListener('scroll', function () {
      navBar.classList.toggle('scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function showToast(msg) {
    var el = document.getElementById('toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'toast';
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2200);
  }

  /* ---------- PDP: gallery ---------- */
  var galMain = document.getElementById('galMain');
  var galThumbBtns = [].slice.call(document.querySelectorAll('.gal-thumbs button[data-media-src]'));
  var galDots = [].slice.call(document.querySelectorAll('.gal-dot'));
  var galIndex = 0;
  function galSync(i) {
    galIndex = i;
    galThumbBtns.forEach(function (b, j) { b.classList.toggle('sel', j === i); });
    galDots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
    /* thumb-carrousel: geselecteerde thumb in beeld scrollen */
    var btn = galThumbBtns[i];
    if (btn && btn.scrollIntoView) {
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }
  if (galMain) {
    document.querySelectorAll('.gal-thumbs button').forEach(function (th) {
      th.addEventListener('click', function () {
        document.querySelectorAll('.gal-thumbs button').forEach(function (b) { b.classList.remove('sel'); });
        th.classList.add('sel');
        if (th.dataset.mediaSrc) {
          /* real product media: swap the main image */
          var img = galMain.querySelector('img');
          if (img) {
            img.src = th.dataset.mediaSrc;
            img.removeAttribute('srcset');
            img.alt = th.dataset.mediaAlt || '';
          }
          galSync(galThumbBtns.indexOf(th));
        } else {
          /* prototype placeholder gallery */
          var ill = galMain.querySelector('.ill');
          var cap = galMain.querySelector('.cap');
          if (ill) ill.textContent = th.dataset.ill;
          if (cap) cap.innerHTML = th.dataset.cap;
          if (th.dataset.bg) galMain.style.background = th.dataset.bg;
        }
      });
    });
  }

  /* ---------- PDP: swipe tussen product-foto's (mobiel) ----------
     Horizontale veeg op het hoofdbeeld bladert door de gallery-media
     (wrap-around); thumbs + dots syncen mee. Na een kleur-swap toont het
     beeld een variant-foto buiten deze lijst — de eerstvolgende veeg pakt
     de gallery weer op bij de laatste index. */
  if (galMain && galThumbBtns.length > 1) {
    var galShow = function (i, dir) {
      var n = galThumbBtns.length;
      var idx = ((i % n) + n) % n;
      var th = galThumbBtns[idx];
      var img = galMain.querySelector('img');
      if (!img || !th) return;
      img.src = th.dataset.mediaSrc;
      img.removeAttribute('srcset');
      img.alt = th.dataset.mediaAlt || '';
      galSync(idx);
      img.classList.remove('gal-anim-left', 'gal-anim-right');
      void img.offsetWidth; /* reflow zodat de animatie opnieuw start */
      img.classList.add(dir === 1 ? 'gal-anim-left' : 'gal-anim-right');
    };
    var swipeX = 0, swipeY = 0, swipeOn = false;
    galMain.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        swipeX = e.touches[0].clientX;
        swipeY = e.touches[0].clientY;
        swipeOn = true;
      }
    }, { passive: true });
    galMain.addEventListener('touchend', function (e) {
      if (!swipeOn) return;
      swipeOn = false;
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        var dir = dx < 0 ? 1 : -1;
        galShow(galIndex + dir, dir);
      }
    }, { passive: true });
  }

  /* ---------- PDP: variant data (real product, prototype fallback) ---------- */
  var sticky = document.getElementById('stickyAtc');
  var buyBox = document.getElementById('buyBox');
  var ladderEl = document.querySelector('.ladder');
  var variantMap = null; /* "option1||option2||option3" -> variant (option3 = Color, '' zonder kleur-optie) */
  var ladderDefaultSize = '';
  var ladderDefaultColor = '';
  function variantKey(o1, o2, o3) {
    return (o1 || '').trim() + '||' + (o2 || '').trim() + '||' + (o3 || '').trim();
  }
  if (ladderEl && ladderEl.dataset.variants) {
    try {
      var parsedVariants = JSON.parse(ladderEl.dataset.variants);
      if (Array.isArray(parsedVariants) && parsedVariants.length) {
        variantMap = {};
        parsedVariants.forEach(function (v) {
          variantMap[variantKey(v.option1, v.option2, v.option3)] = v;
        });
        ladderDefaultSize = ladderEl.dataset.defaultSize || '';
        ladderDefaultColor = ladderEl.dataset.defaultColor || '';
      }
    } catch (err) {
      variantMap = null; /* parse failure → prototype PACKS pricing */
    }
  }
  /* NOTE: Intl en-US approximation ("$54.95") of the store money format,
     using the active Shopify currency (USD fallback); server-rendered
     Liquid prices stay authoritative on load. */
  var moneyFmt = null;
  try {
    if (window.Intl && Intl.NumberFormat) {
      moneyFmt = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }
  } catch (err) {
    moneyFmt = null; /* invalid currency code → fmtMoney fallback */
  }
  function moneyFromCents(cents) {
    return moneyFmt ? moneyFmt.format(cents / 100) : fmtMoney(cents / 100);
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- PDP: size selector ----------
     Real-variant mode: size pills live INSIDE each pack option (.opt-size,
     one shared size state synced across all packs). Fallback mode (no linked
     product): the standalone .sizes row above the ladder. */
  function selectedSize() {
    var s = document.querySelector('.ladder .opt-size.sel') || document.querySelector('.sizes .size.sel');
    if (!s) return ladderDefaultSize || 'M · 28×32 in';
    return s.dataset.size || s.dataset.name;
  }
  document.querySelectorAll('.sizes .size').forEach(function (s) {
    s.addEventListener('click', function () {
      document.querySelectorAll('.sizes .size').forEach(function (b) { b.classList.remove('sel'); });
      s.classList.add('sel');
      var lbl = document.getElementById('sizeLabel');
      if (lbl) lbl.textContent = s.dataset.name;
      updateAtc();
      syncSticky();
    });
  });
  document.querySelectorAll('.ladder .opt-size').forEach(function (s) {
    s.addEventListener('click', function () {
      document.querySelectorAll('.ladder .opt-size').forEach(function (b) {
        b.classList.toggle('sel', b.dataset.size === s.dataset.size);
      });
      document.querySelectorAll('.ladder .opt-size-name').forEach(function (n) {
        n.textContent = s.dataset.size;
      });
      updateLadderPrices();
      updateAtc();
      syncSticky();
    });
  });

  /* ---------- PDP: color selector (één gedeelde kleur-state over alle packs) ---------- */
  function selectedColor() {
    var c = document.querySelector('.ladder .opt-color.sel');
    return c ? c.dataset.color : (ladderDefaultColor || '');
  }
  document.querySelectorAll('.ladder .opt-color').forEach(function (c) {
    c.addEventListener('click', function () {
      document.querySelectorAll('.ladder .opt-color').forEach(function (b) {
        b.classList.toggle('sel', b.dataset.color === c.dataset.color);
      });
      document.querySelectorAll('.ladder .opt-color-name').forEach(function (n) {
        n.textContent = c.dataset.color;
      });
      updateLadderPrices();
      updateAtc();
      syncSticky();
      swapGalleryToVariantImage();
    });
  });

  /* kleur-klik: hoofdbeeld wisselt naar de variant-foto van die kleur
     (variant.featured_image uit de server-rendered variants-JSON).
     Sized CDN-URL (width=1200) + preload van alle kleur-beelden bij idle
     zodat de swap instant is i.p.v. een full-size PNG te streamen. */
  function sizedImageUrl(src, width) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function swapGalleryToVariantImage() {
    var v = currentVariant();
    var img = galMain ? galMain.querySelector('img') : null;
    if (!v || !v.featured_image || !v.featured_image.src || !img) return;
    img.src = sizedImageUrl(v.featured_image.src, 1200);
    img.removeAttribute('srcset');
    img.alt = v.featured_image.alt || '';
    /* de kleur-render is zelf product-media: selecteer de bijbehorende thumb/dot.
       Match op bestandsnaam — thumb-src (storefront /cdn/shop/files/...) en
       variant-src (cdn.shopify.com/s/files/...) hebben verschillende paden. */
    var fileOf = function (u) {
      return (u || '').split('?')[0].split('/').pop();
    };
    var matchIdx = -1;
    var vFile = fileOf(v.featured_image.src);
    galThumbBtns.forEach(function (b, j) {
      if (matchIdx === -1 && fileOf(b.dataset.mediaSrc) === vFile) matchIdx = j;
    });
    if (matchIdx >= 0) {
      galSync(matchIdx);
    } else {
      document.querySelectorAll('.gal-thumbs button').forEach(function (b) { b.classList.remove('sel'); });
      document.querySelectorAll('.gal-dot').forEach(function (d) { d.classList.remove('on'); });
    }
  }
  if (variantMap) {
    var preloadColorImages = function () {
      var seen = {};
      Object.keys(variantMap).forEach(function (k) {
        var v = variantMap[k];
        if (v && v.featured_image && v.featured_image.src && !seen[v.featured_image.src]) {
          seen[v.featured_image.src] = true;
          new Image().src = sizedImageUrl(v.featured_image.src, 1200);
        }
      });
    };
    if (window.requestIdleCallback) requestIdleCallback(preloadColorImages, { timeout: 4000 });
    else setTimeout(preloadColorImages, 2500);
  }

  /* "Size chart"-link bij de size-pills: opent het specs-accordion en scrolt ernaartoe */
  document.querySelectorAll('[data-size-chart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var chart = document.getElementById('sizeChart');
      if (!chart) return;
      var item = chart.closest('.ai');
      if (item && !item.classList.contains('open')) {
        var accBtn = item.querySelector('button');
        if (accBtn) accBtn.click();
      }
      setTimeout(function () { chart.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 180);
    });
  });

  /* keep every pack row's price true for the selected size + color */
  function updateLadderPrices() {
    if (!variantMap) return;
    var size = selectedSize();
    var color = selectedColor();
    document.querySelectorAll('.ladder .opt').forEach(function (o) {
      var v = variantMap[variantKey(size, o.dataset.packName, color)];
      if (!v) return;
      var now = o.querySelector('.price .now');
      var was = o.querySelector('.price .was');
      if (now) now.textContent = moneyFromCents(v.price);
      if (was) was.textContent = (v.compare_at_price && v.compare_at_price > v.price) ? moneyFromCents(v.compare_at_price) : '';
    });
  }

  /* ---------- PDP: pack ladder ---------- */
  var currentPack = 2;
  function selectedPackName() {
    var o = document.querySelector('.ladder .opt.sel');
    if (o && o.dataset.packName) return o.dataset.packName;
    return PACKS[currentPack] ? PACKS[currentPack].name : '';
  }
  function currentVariant() {
    if (!variantMap) return null;
    return variantMap[variantKey(selectedSize(), selectedPackName(), selectedColor())] || null;
  }
  function updateAtc() {
    var atc = document.getElementById('atcBtn');
    var hidden = document.getElementById('variantId');
    var stickyBtn = sticky ? sticky.querySelector('.btn') : null;
    if (variantMap) {
      var v = currentVariant();
      var ok = !!(v && v.available !== false);
      if (atc) {
        atc.textContent = ok ? 'Add to cart — ' + moneyFromCents(v.price) : 'Unavailable';
        if (ok) atc.removeAttribute('disabled'); else atc.setAttribute('disabled', '');
      }
      if (stickyBtn) {
        if (ok) stickyBtn.removeAttribute('disabled'); else stickyBtn.setAttribute('disabled', '');
      }
      if (hidden) hidden.value = ok ? String(v.id) : '';
    } else if (atc && PACKS[currentPack]) {
      atc.textContent = 'Add to cart — ' + fmtMoney(PACKS[currentPack].price);
    }
  }
  function selectPack(n) {
    currentPack = n;
    document.querySelectorAll('.ladder .opt').forEach(function (o) {
      var on = o.dataset.pack === String(n);
      o.classList.toggle('sel', on);
      var wrap = o.closest('.opt-wrap');
      if (wrap) wrap.classList.toggle('sel', on);
    });
    updateAtc();
    syncSticky();
  }
  document.querySelectorAll('.ladder .opt').forEach(function (o) {
    o.addEventListener('click', function () { selectPack(parseInt(o.dataset.pack, 10)); });
  });

  var packParam = new URLSearchParams(location.search).get('pack');
  if (packParam && /^\d+$/.test(packParam) && document.querySelector('.ladder .opt[data-pack="' + packParam + '"]')) {
    selectPack(parseInt(packParam, 10));
  }

  /* ---------- PDP: sticky ATC bar ---------- */
  function syncSticky() {
    if (!sticky) return;
    var name, priceText;
    if (variantMap) {
      var v = currentVariant();
      name = selectedPackName();
      priceText = v ? moneyFromCents(v.price) : '—';
    } else {
      var p = PACKS[currentPack] || PACKS[2];
      name = selectedPackName() || p.name;
      priceText = fmtMoney(p.price);
    }
    /* korte maat ("M" uit "M · 70×80 cm") — volledige titel maakt de pill te breed op mobile */
    var sizeShort = (selectedSize() || '').split(' · ')[0];
    var colorName = selectedColor();
    sticky.querySelector('.t').innerHTML =
      escapeHtml(name) + ' · ' + escapeHtml(sizeShort) +
      (colorName ? ' · ' + escapeHtml(colorName) : '') +
      '<small><span class="pr-s">' + priceText + '</span> — free shipping</small>';
  }
  if (sticky && buyBox) {
    syncSticky();
    var sIO = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    sIO.observe(buyBox);
  }
  if (document.getElementById('atcBtn')) { updateLadderPrices(); updateAtc(); }

  /* ---------- PDP: layer diagram ----------
     Each layer's info content is server-rendered into a
     <template data-layer-info="n"> inside .layers-wrap; clicking a
     layer copies that template's content into #layerInfo. */
  var layerInfo = document.getElementById('layerInfo');
  if (layerInfo) {
    document.querySelectorAll('.layer').forEach(function (l) {
      l.addEventListener('click', function () {
        var wrap = l.closest('.layers-wrap');
        var tpl = wrap ? wrap.querySelector('template[data-layer-info="' + l.dataset.layer + '"]') : null;
        if (tpl) {
          document.querySelectorAll('.layer').forEach(function (x) { x.classList.remove('on'); });
          l.classList.add('on');
          layerInfo.innerHTML = '';
          layerInfo.appendChild(tpl.content.cloneNode(true));
        }
      });
    });
  }

  /* ---------- PDP: boop-math calculator ---------- */
  var slider = document.getElementById('bmSlider');
  if (slider) {
    var bmCard = slider.closest('.bm');
    var DISP_COST = bmCard ? parseFloat(bmCard.dataset.disposableCost) : NaN;
    if (isNaN(DISP_COST)) DISP_COST = 0.90;
    if (!(DISP_COST > 0)) DISP_COST = 0.90;
    var PAD_PRICE = bmCard ? parseFloat(bmCard.dataset.padPrice) : NaN;
    if (isNaN(PAD_PRICE)) PAD_PRICE = 100;
    if (!(PAD_PRICE > 0)) PAD_PRICE = 100;
    function calc() {
      var perDay = parseInt(slider.value, 10);
      var yearly = Math.round(perDay * 365 * DISP_COST);
      document.getElementById('bmPads').textContent = perDay;
      document.getElementById('bmDisp').textContent = '$' + yearly;
      document.getElementById('bmSave').textContent = '$' + Math.max(0, Math.round(yearly - PAD_PRICE)) + ' saved';
      var months;
      if (yearly > 0) {
        months = Math.max(1, Math.round(PAD_PRICE / (yearly / 12)));
      } else {
        months = Math.max(1, Math.round(PAD_PRICE / (DISP_COST * 365 / 12)));
      }
      document.getElementById('bmPayback').textContent = months <= 1 ? '~1 month' : '~' + months + ' months';
    }
    slider.addEventListener('input', calc);
    calc();
  }

  /* ============================================================
     CART — drawer on the Shopify AJAX Cart API
     Markup is server-rendered (snippets/hisnoot-cart-drawer.liquid);
     after every mutation the line items are re-fetched through the
     Section Rendering API (sections/hisnoot-cart-drawer-items.liquid),
     so all merchant/cart data stays server-escaped.
     ============================================================ */
  var drawer = document.getElementById('drawer');
  var drOverlay = document.getElementById('drOverlay');
  var drItems = document.getElementById('drItems');
  var drFoot = document.getElementById('drFoot');
  var CART_ERROR_MSG = 'Something went wrong — try again ✦';
  var DRAWER_SECTION = 'hisnoot-cart-drawer-items';

  /* Free gift: a 6-pack in the cart auto-adds the enzyme cleaner (the BXGY
     automatic discount makes it 100% free at checkout — display logic never
     trusts the Cart API price for it).
     Gated on the theme setting "enable_free_gift" (data-free-gift on #drawer):
     OFF = no auto-add/remove; requires cleaner product ACTIVE + BXGY active.
     NB: lijst dekt alleen de GRAY 6-packs — sinds de Color-optie (2026-06-12)
     bestaan er 12 six-pack-varianten; bij re-enable ook BRB/BGE/WHT-ids
     toevoegen én de BXGY-discount op alle 6-pack-varianten zetten. */
  var SIXPACK_IDS = [51692445335850, 51692445434154, 51692445532458];
  var CLEANER_ID = 51692968116522;
  var CLEANER_DISMISS_KEY = 'hisnoot_cleaner_dismissed';
  var cleanerOpPending = false;
  var FREE_GIFT_ON = !!(drawer && drawer.dataset.freeGift === '1');

  function cleanerDismissed() {
    try {
      return sessionStorage.getItem(CLEANER_DISMISS_KEY) === '1';
    } catch (e) {
      return false; /* storage blocked → behave as not dismissed */
    }
  }
  function dismissCleaner() {
    try {
      sessionStorage.setItem(CLEANER_DISMISS_KEY, '1');
    } catch (e) { /* storage blocked → worst case the gift re-adds */ }
  }

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* Mutation queue: every cart mutation (add/change/upgrade, including its
     DOM refresh) is chained on one module-level promise so requests can
     never interleave — line items and section renders stay consistent. */
  var cartQueue = Promise.resolve();
  function enqueue(fn) {
    cartQueue = cartQueue.then(fn, fn);
    return cartQueue;
  }

  function setBusy(on) {
    if (drItems) drItems.classList.toggle('dr-busy', !!on);
  }

  function cartErrorToast(err) {
    showToast((err && err.friendly) || CART_ERROR_MSG);
  }

  async function cartFetchJson(url, options) {
    var res = await fetch(url, options);
    if (!res.ok) {
      var friendly = '';
      try {
        var body = await res.json();
        if (body) friendly = body.description || body.message || '';
      } catch (e) { /* non-JSON error body */ }
      var err = new Error(friendly || 'Cart request failed (' + res.status + ')');
      if (friendly) err.friendly = friendly;
      throw err;
    }
    return res.json();
  }

  function cartPost(path, payload) {
    return cartFetchJson(shopRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  /* /cart/add.js → response is the added item(s) + requested sections */
  function cartAdd(id, qty) {
    return cartPost('cart/add.js', {
      items: [{ id: id, quantity: qty }],
      sections: DRAWER_SECTION
    });
  }

  /* /cart/change.js on the line-item key → response is the full cart + sections */
  function cartChangeKey(key, qty) {
    return cartPost('cart/change.js', {
      id: key,
      quantity: qty,
      sections: DRAWER_SECTION
    });
  }

  /* Replace #drItems with the server-rendered (server-escaped) section
     markup bundled in an add/change response. Returns false when the
     response carried no section so callers can fall back to refreshDrawer. */
  function applySections(response) {
    var sectionHtml = response && response.sections && response.sections[DRAWER_SECTION];
    if (!drItems || typeof sectionHtml !== 'string') return false;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var wrap = doc.querySelector('.shopify-section') || doc.body;
    while (drItems.firstChild) drItems.removeChild(drItems.firstChild);
    while (wrap.firstChild) drItems.appendChild(wrap.firstChild);
    restoreDrawerFocus();
    return true;
  }

  function applyCartState(cartData) {
    document.querySelectorAll('.cart').forEach(function (c) {
      c.setAttribute('data-count', cartData.item_count);
    });
    var sub = document.getElementById('drSubtotal');
    if (sub) sub.textContent = moneyFromCents(cartData.total_price);
    if (drFoot) drFoot.style.display = cartData.item_count > 0 ? '' : 'none';
  }

  /* Free-gift evaluation, called wherever fresh cart items are available.
     Loop safety: the gift op itself triggers a sync whose re-evaluation is
     blocked by cleanerOpPending (still true until the op's finally); after
     that, add/remove conditions are each other's complement — post auto-add
     the state is has6pack && cleaner (no branch), post auto-remove it is
     !has6pack && !cleaner (no branch) — so no ping-pong is possible. */
  function evaluateCleanerGift(cartItems) {
    if (!FREE_GIFT_ON || cleanerOpPending || !Array.isArray(cartItems)) return;
    var hasSixPack = cartItems.some(function (item) {
      return SIXPACK_IDS.indexOf(item.id) !== -1;
    });
    var cleanerItem = null;
    cartItems.forEach(function (item) {
      if (!cleanerItem && item.id === CLEANER_ID) cleanerItem = item;
    });
    if (hasSixPack && !cleanerItem) {
      if (cleanerDismissed()) return;
      cleanerOpPending = true;
      enqueue(async function () {
        setBusy(true);
        try {
          await syncAfterAdd(await cartAdd(CLEANER_ID, 1));
          showToast('🎁 FREE Enzyme Cleaner added!');
        } catch (err) {
          /* best-effort: no toast spam — the BXGY deal still applies at
             checkout if the customer adds the cleaner themselves */
        } finally {
          setBusy(false);
          cleanerOpPending = false;
        }
      });
    } else if (!hasSixPack && cleanerItem) {
      cleanerOpPending = true;
      enqueue(async function () {
        setBusy(true);
        try {
          await syncAfterChange(await cartChangeKey(cleanerItem.key, 0));
        } catch (err) { /* best-effort: next mutation re-evaluates */ }
        finally {
          setBusy(false);
          cleanerOpPending = false;
        }
      });
    }
  }

  /* Does the rendered drawer contain a 6-pack line? (rm buttons carry
     data-variant-id; used for the dismiss check at click-time) */
  function drawerHasSixPack() {
    if (!drItems) return false;
    var rms = drItems.querySelectorAll('[data-act="rm"][data-variant-id]');
    for (var i = 0; i < rms.length; i++) {
      if (SIXPACK_IDS.indexOf(parseInt(rms[i].dataset.variantId, 10)) !== -1) return true;
    }
    return false;
  }

  /* Utility for responses without a bundled section (fallback paths). */
  async function refreshDrawer() {
    var root = shopRoot();
    var results = await Promise.all([
      cartFetchJson(root + '?sections=' + DRAWER_SECTION),
      cartFetchJson(root + 'cart.js')
    ]);
    applySections({ sections: results[0] });
    applyCartState(results[1]);
    evaluateCleanerGift(results[1].items);
  }

  /* change.js returns the full cart: section + badge/subtotal from one response */
  async function syncAfterChange(cart) {
    if (applySections(cart)) {
      applyCartState(cart);
      evaluateCleanerGift(cart.items);
    } else {
      await refreshDrawer();
    }
  }

  /* add.js returns the item, not the cart: section from the response,
     count/total via one /cart.js call inside the same queue operation
     (the queue guarantees no interleaving mutation). */
  async function syncAfterAdd(addResponse) {
    if (applySections(addResponse)) {
      var cartData = await cartFetchJson(shopRoot() + 'cart.js');
      applyCartState(cartData);
      evaluateCleanerGift(cartData.items);
    } else {
      await refreshDrawer();
    }
  }

  /* Atomic-ish upgrade: add the new pack first (a failed add loses nothing),
     then remove the old line; if the remove fails the user keeps both and
     gets told to remove the old pack manually. */
  async function cartUpgrade(oldKey, variantId, qty) {
    var addResponse = await cartAdd(variantId, qty);
    try {
      await syncAfterChange(await cartChangeKey(oldKey, 0));
    } catch (err) {
      showToast('Upgrade added — remove the old pack manually');
      try {
        await syncAfterAdd(addResponse);
      } catch (e) { /* best-effort refresh; upgrade itself is in the cart */ }
    }
  }

  var lastFocus = null;

  function restoreDrawerFocus() {
    /* a section swap can drop focus to <body>; pull it back into the dialog */
    if (
      drawer &&
      drawer.classList.contains('open') &&
      (!document.activeElement || document.activeElement === document.body)
    ) {
      drawer.focus();
    }
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    if (drOverlay) drOverlay.classList.add('open');
    drawer.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (drOverlay) drOverlay.classList.remove('open');
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  if (drawer) {
    document.querySelectorAll('a.cart').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        openDrawer();
      });
    });
    var drClose = document.getElementById('drClose');
    var drCont = document.getElementById('drCont');
    if (drClose) drClose.addEventListener('click', closeDrawer);
    if (drCont) drCont.addEventListener('click', closeDrawer);
    if (drOverlay) drOverlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
  }

  function addAndOpen(btn, variantId, qty) {
    btn.setAttribute('disabled', '');
    return enqueue(async function () {
      setBusy(true);
      try {
        var addResponse = await cartAdd(variantId, qty);
        try {
          await syncAfterAdd(addResponse);
        } catch (err) {
          /* the item IS in the cart — open anyway, badge best-effort, no toast */
          try {
            var cartData = await cartFetchJson(shopRoot() + 'cart.js');
            applyCartState(cartData);
            evaluateCleanerGift(cartData.items);
          } catch (e) { /* ignore */ }
        }
        openDrawer();
      } catch (err) {
        cartErrorToast(err);
      } finally {
        setBusy(false);
        btn.removeAttribute('disabled');
      }
    });
  }

  document.querySelectorAll('[data-add-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = parseInt(btn.dataset.addVariant, 10);
      if (!id) { showToast(CART_ERROR_MSG); return; }
      addAndOpen(btn, id, 1);
    });
  });

  document.querySelectorAll('[data-add-variant-dynamic]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hidden = document.getElementById('variantId');
      var id = hidden ? parseInt(hidden.value, 10) : NaN;
      if (!id) { showToast('Pick a pack first ✦'); return; }
      addAndOpen(btn, id, 1);
    });
  });

  if (drItems) {
    drItems.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-upgrade-variant], [data-act]');
      if (!btn || btn.hasAttribute('disabled') || !drItems.contains(btn)) return;
      btn.setAttribute('disabled', '');
      enqueue(async function () {
        /* guard: btn captured at click-time can be detached after a prior
           queued op's section swap — its qty/key would be stale */
        if (!drItems.contains(btn)) return;
        setBusy(true);
        try {
          if (btn.dataset.upgradeVariant) {
            if (!btn.dataset.upgradeKey) return;
            await cartUpgrade(
              btn.dataset.upgradeKey,
              parseInt(btn.dataset.upgradeVariant, 10),
              parseInt(btn.dataset.upgradeQty, 10) || 1
            );
          } else {
            var key = btn.dataset.key;
            if (!key) return;
            var qtyWrap = btn.closest('.dr-qty');
            var qtyEl = qtyWrap ? qtyWrap.querySelector('span') : null;
            var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : NaN;
            var nextQty = null;
            if (btn.dataset.act === 'rm') {
              nextQty = 0;
              /* removing the free cleaner while a 6-pack is still in the
                 cart = an explicit dismiss → don't re-add this session */
              if (parseInt(btn.dataset.variantId, 10) === CLEANER_ID && drawerHasSixPack()) {
                dismissCleaner();
              }
            } else if (btn.dataset.act === 'inc' && qty >= 1) {
              nextQty = qty + 1;
            } else if (btn.dataset.act === 'dec' && qty >= 1) {
              nextQty = qty - 1; /* quantity 0 removes the line */
            }
            if (nextQty === null) return;
            await syncAfterChange(await cartChangeKey(key, nextQty));
          }
        } catch (err) {
          cartErrorToast(err);
        } finally {
          setBusy(false);
          /* btn is usually replaced by the section swap; harmless if detached */
          btn.removeAttribute('disabled');
        }
      });
    });
  }
  /* no refreshDrawer() on load: drawer contents and header data-count
     are already server-rendered with the live cart. */

  /* ============================================================
     EMAIL CAPTURE POPUP
     Triggers on first qualifying signal (delay / scroll 45% / exit-intent),
     once per visitor. Captures via the customer form (newsletter tag →
     Shopify customers; Klaviyo syncs later). AJAX-submitted with optimistic
     success; falls back to a native submit if fetch is unavailable.
     ============================================================ */
  var popup = document.getElementById('emailPopup');
  if (popup) {
    var epOverlay = document.getElementById('epOverlay');
    var epForm = document.getElementById('epForm');
    var epDone = document.getElementById('epDone');
    var epFormEl = document.getElementById('hisnootPopupForm');
    var epEmail = document.getElementById('ep-email');
    var epErr = document.getElementById('epErr');
    var epCodeBtn = document.getElementById('epCode');
    var SEEN_KEY = 'hisnoot_popup_v1';
    var SUCCESS_KEY = 'hisnoot_popup_success';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var popupShown = false;
    var epLastFocus = null;

    function epSeen() {
      try { return localStorage.getItem(SEEN_KEY); } catch (e) { return null; }
    }
    function epMark(val) {
      try { localStorage.setItem(SEEN_KEY, val); } catch (e) { /* storage blocked */ }
    }
    function epSuccessPending() {
      try { return localStorage.getItem(SUCCESS_KEY) === '1'; } catch (e) { return false; }
    }

    var epReadyAt = Date.now() + 1500; /* nooit binnen 1,5s na load openen */
    function openPopup() {
      if (popupShown || epSeen() || Date.now() < epReadyAt) return;
      popupShown = true;
      epLastFocus = document.activeElement;
      popup.hidden = false;
      if (epOverlay) epOverlay.hidden = false;
      /* next frame: add .open for the transition */
      requestAnimationFrame(function () {
        popup.classList.add('open');
        if (epOverlay) epOverlay.classList.add('open');
      });
      if (epEmail) setTimeout(function () { epEmail.focus(); }, 320);
    }

    function closePopup(persist) {
      popup.classList.remove('open');
      if (epOverlay) epOverlay.classList.remove('open');
      setTimeout(function () {
        popup.hidden = true;
        if (epOverlay) epOverlay.hidden = true;
      }, 300);
      if (persist) epMark('dismissed');
      if (epLastFocus && typeof epLastFocus.focus === 'function' && document.contains(epLastFocus)) {
        epLastFocus.focus();
      }
    }

    /* ---- triggers (first one wins) ---- */
    if (!epSeen()) {
      var delay = parseInt(popup.dataset.delay, 10);
      if (isNaN(delay) || delay < 0) delay = 15;
      setTimeout(openPopup, delay * 1000);

      var onScroll = function () {
        var sc = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight || 1);
        if (sc > 0.6) { openPopup(); window.removeEventListener('scroll', onScroll); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      /* exit-intent (desktop): only after the cursor has genuinely been
         inside the page (mousemove below the top edge), then leaves toward
         the top. This avoids the "cursor parked at the top on load" false
         trigger entirely. */
      var mouseInside = false;
      var onMove = function (e) {
        if (e.clientY > 60) { mouseInside = true; document.removeEventListener('mousemove', onMove); }
      };
      document.addEventListener('mousemove', onMove);
      var onExit = function (e) {
        if (mouseInside && e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
          openPopup();
          document.removeEventListener('mouseout', onExit);
        }
      };
      document.addEventListener('mouseout', onExit);
    }

    /* ---- close handlers ---- */
    var epCloseBtn = document.getElementById('epClose');
    var epNope = document.getElementById('epNope');
    if (epCloseBtn) epCloseBtn.addEventListener('click', function () { closePopup(true); });
    if (epNope) epNope.addEventListener('click', function () { closePopup(true); });
    if (epOverlay) epOverlay.addEventListener('click', function () { closePopup(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('open')) closePopup(true);
    });
    /* light focus trap: keep Tab inside the dialog */
    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = popup.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
      var list = [].slice.call(focusables).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    function showSuccess() {
      epMark('subscribed');
      if (epForm) epForm.hidden = true;
      if (epDone) epDone.hidden = false;
      /* best-effort clipboard copy of the code */
      var code = popup.dataset.code || 'BOOP10';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).catch(function () { /* clipboard blocked */ });
      }
      if (epDone) {
        var h = epDone.querySelector('h2');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
      }
    }

    /* ---- submit ----
       Let the customer form submit natively to /contact. Shopify (incl. its
       captcha) records the email and redirects back here — a page reload.
       This is the proven capture path. We can't show the success screen
       in-place (the reload would wipe it, and hiding the form to keep it
       would abort the submission), so we flag success and re-open the popup
       into the success state right after the reload (handled below). */
    if (epFormEl) {
      epFormEl.addEventListener('submit', function (e) {
        var email = epEmail ? epEmail.value.trim() : '';
        if (!EMAIL_RE.test(email)) {
          e.preventDefault();
          if (epErr) { epErr.textContent = 'Please enter a valid email ✦'; epErr.hidden = false; }
          if (epEmail) epEmail.focus();
          return;
        }
        try { localStorage.setItem(SUCCESS_KEY, '1'); } catch (err) { /* storage blocked */ }
        epMark('subscribed');
        /* no preventDefault, no form hiding → native submit fires + reloads */
      });
    }

    /* after a capture reload: reopen straight into the success state */
    if (epSuccessPending()) {
      try { localStorage.removeItem(SUCCESS_KEY); } catch (err) { /* ignore */ }
      popupShown = true;
      popup.hidden = false;
      if (epOverlay) epOverlay.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('open');
        if (epOverlay) epOverlay.classList.add('open');
      });
      showSuccess();
    }

    if (epCodeBtn) {
      epCodeBtn.addEventListener('click', function () {
        var code = popup.dataset.code || 'BOOP10';
        var label = epCodeBtn.querySelector('.ep-code-copy');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            if (label) { label.textContent = 'Copied!'; setTimeout(function () { label.textContent = 'Copy'; }, 1800); }
          }).catch(function () { /* ignore */ });
        }
      });
    }
  }
})();
